export default __webpack_public_path__ + "static/media/metamask.955ae741.svg";